import { render, staticRenderFns } from "./AboutDropbox.vue?vue&type=template&id=5683112a&"
import script from "./AboutDropbox.vue?vue&type=script&lang=js&"
export * from "./AboutDropbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports